// src/components/RequestAccess.jsx
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import backaero from "@assets/icons/backaero.png";
import rightArrow from "@assets/icons/rightArrow.png";
import SC from "./style";
import theme from "theme";
import { TextInput } from "@InnoInput";
import { InputField, TimeZoneWithCountryDropdown } from "@components/";
import ct from "countries-and-timezones";
import { apiPost } from "api/callApi";
import { showAlert } from "utils/helper";
import { Button } from "@InnoUI/";
import {
  regexTypes,
  validateEmail,
  validateEmail2,
  validtionMessages,
} from "utils/config";

const RequestAccess = (props) => {
  const { setCurrentView } = props;
  const [countryOptions, setCountryOptions] = useState([]);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    mobile: "",
    country: "",
    Message: "",
    hearAbout: "",
  });
  const [loading, setLoading] = useState(false);
  const [errorKeys, setErrorKeys] = useState({
    email: false,
  });

  useEffect(() => {
    const allCountries = ct.getAllCountries();
    const countryList = Object.values(allCountries).map((country) => ({
      label: country.name,
      value: country.id,
      timezones: country.timezones,
    }));
    setCountryOptions(countryList);
  }, []);

  const handleChange = (name, value) => {
    if (name === "email") {
      if (!validateEmail(value)) {
        setErrorKeys((prevKeys) => ({ ...prevKeys, [name]: true }));
      } else {
        setErrorKeys((prevKeys) => ({ ...prevKeys, [name]: false }));
      }
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value || "",
    }));
  };

  const handleCountryChange = (countryId) => {
    const selectedCountry = countryOptions.find(
      (country) => country.value === countryId
    );
    setFormData((prevData) => ({
      ...prevData,
      country: selectedCountry?.value || "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.country) {
      showAlert({title: "Error", text: "Please select a country.", icon: "error"});
      return;
    }

    if (!validateEmail(formData.email)) {
      setErrorKeys((prevKeys) => ({ ...prevKeys, email: true }));
      return;
    }

    try {
      setLoading(true);
      const response = await apiPost("/v1/requestaccess", formData);
      showAlert({title: "Success", text: response?.message, icon: "success"});
      setLoading(false);
      setFormData({
        fullName: "",
        email: "",
        mobile: "",
        country: "",
        Message: "",
        hearAbout: "",
      });
      setCurrentView("login");
    } catch (error) {
      console.error("Error:", error);
      showAlert({title: "Error", text: error?.response?.data?.message, icon: "error"});
      setLoading(false);
    }
  };

  const Reqdetails = [
    { title: "Reason for requesting access to system", icon: rightArrow },
    { title: "Full Name", icon: rightArrow },
    { title: "E-mail address", icon: rightArrow },
    { title: "Contact Details", icon: rightArrow },
  ];

  return (
    <>
   
      <SC.Requestform>
        <SC.RequestHeading>Request Access to the Bimbild</SC.RequestHeading>
        <SC.Form2 onSubmit={handleSubmit}>
          <SC.DivC>
            <SC.FormGroup>
              <SC.Label2>
                Full name <SC.Astrik>*</SC.Astrik>
              </SC.Label2>
              <InputField
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                type="text"
                style={{ width: "100%", height: "19px", borderRadius: "6px" }}
                required
                regexType={regexTypes.textOnly}
              />
            </SC.FormGroup>

            <SC.FormGroup>
              <SC.Label2>
                Email <SC.Astrik>*</SC.Astrik>
              </SC.Label2>
              <InputField
                name="email"
                value={formData.email}
                onChange={handleChange}
                type="email"
                style={{ width: "100%", height: "19px", borderRadius: "6px" }}
                required
              />
              {errorKeys.email && (
                <SC.ValidtionMessages>
                  {validtionMessages.email}
                </SC.ValidtionMessages>
              )}
            </SC.FormGroup>

            <SC.FormGroup>
              <SC.Label2>
                Mobile number <SC.Astrik>*</SC.Astrik>
              </SC.Label2>
              <InputField
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                type="number"
                maxLength={15}
                style={{ width: "100%", height: "19px", borderRadius: "6px" }}
                required
              />
            </SC.FormGroup>

            <SC.FormGroup>
              <SC.Label2>
                Country <SC.Astrik>*</SC.Astrik>
              </SC.Label2>
              <TimeZoneWithCountryDropdown
                placeholder="Select Country"
                options={countryOptions}
                value={formData.country}
                onChange={handleCountryChange}
                width="105%"
                height="35px"
              />
            </SC.FormGroup>

            <SC.FormGroup className="full-width">
              <SC.Label2>
                Message <SC.Astrik>*</SC.Astrik>
              </SC.Label2>
              <SC.StyledTextArea
                name="Message"
                value={formData.Message}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                maxLength={1000}
                required
              />
            </SC.FormGroup>

            <SC.FormGroup className="full-width">
              <SC.Label2>Where did you hear about us?</SC.Label2>
              {/* <InputField
            name="hearAbout"
            value={formData.hearAbout}
            onChange={handleChange}
            type="text"
            style={{ width: "98%", height: "19px", borderRadius: "6px" }}
          /> */}

              <SC.StyledTextArea
                name="hearAbout"
                value={formData.hearAbout}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                maxLength={1000}
                required
              />
              {/* <TextInput
            name="hearAbout"
            value={formData.hearAbout}
            onChange={(value, name) => handleChange(name, value)}
            isTextArea
            maxLength={1000}
            size="large"
            style={{
              height: "80px",
              fontSize: "16px",
              width: "100%",
              border: `1px solid ${theme.colors.bordertask}`,
              borderRadius: "6px",
              // resize: "none",
              minHeight: "80px",
            }}
          /> */}
            </SC.FormGroup>
          </SC.DivC>
          {/* <Button caption="adsada" type="submit" /> */}
          <SC.RequestAccessButton>
            <SC.ReqButton type="submit">
              {loading ? "Sending..." : "Send Request"}
            </SC.ReqButton>
          </SC.RequestAccessButton>

          <SC.BackButton>
            <span onClick={() => setCurrentView("login")}>
              <img
                src={backaero}
                alt="Back"
                style={{
                  height: "10px",
                  width: "10px",
                  marginRight: "5px",
                  // marginBottom: "2px",
                }}
              />
              Back to Log in
            </span>
          </SC.BackButton>
        </SC.Form2>
      </SC.Requestform>
    </>
  );
};

export default RequestAccess;
